<template>
  <div class="bankcard">
    <p>付款账户：招商银行股份有限公司北京青年路支行</p>
    <p>收 款 人： 北京创知后的科技有限公司</p>
    <p>开 户 行： 招商银行股份有限公司北京青年路支行</p>
    <p>账 号： 1109 2357 7310 301</p>
    <div class="onloadImg"><img src="@/assets/imgs/onloadImg.png" alt=""></div>
    <span>请上传线下支付凭证</span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.bankcard {
  width: 100%;
  p {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 17px;
    margin-bottom: 10px;
  }
  .onloadImg{
      width: 60px;
      height: 60px;
      border: 1px solid #CCCCCC;
      margin-top: 5px;
      margin-bottom: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img{
          width: 17px;
          height: 17px;
      }
  }
  span {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 17px;
  }
}
</style>
